import InputCounter from "./InputCounter";

export default InputCounter;
